import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-wizard-head',
  templateUrl: './wizard-head.component.html',
  styleUrls: ['./wizard-head.component.scss']
})
export class WizardHeadComponent implements OnInit, OnDestroy {
  observableSubscription$ = new Subject();
  @Input() wizardInput: any;

  constructor(public immigrationWizardService: ImmigrationWizardService) { }

  ngOnInit(): void {
    this.immigrationWizardService.getWizardTaskHeaderDetails$().pipe(takeUntil(this.observableSubscription$)).subscribe((res: any) => {
      if(res && this.wizardInput){
        this.wizardInput['data']['status'] = res?.taskStatus?.name
      }
    });
  } 

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
